import { useViewState } from './navigation'
import type { SetStateAction } from 'react'

/** Незавершённая форма возвращается с историей; явная отмена/сохранение очищает её. */
export function useViewDraft<T>(key: string, initial: T | (() => T)) {
  const [draft, setDraft] = useViewState<{ value: T } | null>(key, null)
  const defaults = () => typeof initial === 'function' ? (initial as () => T)() : initial
  const value = draft === null ? defaults() : draft.value
  const setValue = (next: SetStateAction<T>) => setDraft((previous) => ({
    value: typeof next === 'function'
      ? (next as (value: T) => T)(previous === null ? defaults() : previous.value)
      : next,
  }))
  const reset = () => setDraft(null)
  return [value, setValue, reset] as const
}
